// PARAQTA — Рефлексия модалы (#reflModal). HTML index.html-де сақталады.
// Module-internal state: _reflBookId, _reflRating.

import { toast } from '../../utils/toast.js';

let _reflBookId = null, _reflRating = null;

export function openReflectionModal(bookId, bookTitle) {
  _reflBookId = bookId; _reflRating = null;
  document.getElementById('reflBookTitle').textContent = bookTitle || '';
  ['refl-idea-0','refl-idea-1','refl-idea-2'].forEach(id => { document.getElementById(id).value = ''; });
  document.getElementById('refl-note').value = '';
  document.getElementById('refl-action').value = '';
  document.getElementById('refl-public').checked = false;
  setReflRating(null);
  fetch('/api/books/' + bookId + '/reflection', { credentials: 'include' })
    .then(r => r.ok ? r.json() : null)
    .then(data => {
      if (!data) return;
      (data.key_ideas || []).forEach((v, i) => { const el = document.getElementById('refl-idea-' + i); if (el) el.value = v; });
      document.getElementById('refl-note').value = data.personal_note || '';
      document.getElementById('refl-action').value = (data.action_points || [])[0] || '';
      document.getElementById('refl-public').checked = !!data.is_public;
      if (data.rating) setReflRating(data.rating);
    }).catch(() => {});
  document.getElementById('reflModal').style.display = 'flex';
}

export function closeReflectionModal() {
  document.getElementById('reflModal').style.display = 'none';
}

export function setReflRating(v) {
  _reflRating = v;
  document.querySelectorAll('#reflStars span').forEach((s, i) => {
    const on = v !== null && i < v;
    s.textContent = on ? '★' : '☆';
    s.style.color = on ? 'var(--gold)' : 'var(--ink4)';
  });
}

export async function saveReflection() {
  if (!_reflBookId) return;
  const key_ideas = ['refl-idea-0','refl-idea-1','refl-idea-2']
    .map(id => document.getElementById(id).value.trim()).filter(Boolean);
  const personal_note = document.getElementById('refl-note').value.trim();
  const action_val = document.getElementById('refl-action').value.trim();
  const action_points = action_val ? [action_val] : [];
  const is_public = document.getElementById('refl-public').checked;
  const r = await fetch('/api/books/' + _reflBookId + '/reflection', {
    method: 'POST', credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ key_ideas, personal_note, action_points, rating: _reflRating, is_public })
  });
  if (r.ok) { toast('\u2713 Рефлексия сақталды'); closeReflectionModal(); }
  else toast('Қате болды');
}
